import { useIonViewDidEnter } from '@ionic/react';
import { useEffect } from 'react';
export function usePublicRequest(cb: any, triggers: any[] = []) {
  const callback = () => {
    cb();
  };
  useEffect(callback, [...triggers]);
}
